var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoodIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Food"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.77,14.82c.67,0,1.22-.55,1.22-1.22v-4.57c0-.67-.55-1.22-1.22-1.22s-1.22,.55-1.22,1.22v4.57c0,.67,.55,1.22,1.22,1.22Z",
    style: {
      fill: "#141344"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.16,8.83c-.11-.66-.74-1.11-1.4-1-.67,.11-1.11,.74-1,1.4l.9,5.38c-.02,.74-.32,1.43-.85,1.96-.54,.54-1.26,.84-2.02,.85h-.04c-.77,0-1.49-.3-2.03-.85-.52-.52-.82-1.22-.85-1.96l.9-5.38c.11-.66-.34-1.29-1-1.4-.67-.11-1.29,.34-1.4,1l-.91,5.49c0,.06-.01,.13-.01,.2,0,1.42,.55,2.76,1.56,3.77,.71,.71,1.59,1.19,2.55,1.42v11.27c0,.67,.55,1.22,1.22,1.22h0c.67,0,1.22-.54,1.22-1.22v-11.28c.95-.22,1.83-.7,2.54-1.41,1.01-1.01,1.56-2.35,1.56-3.77,0-.07,0-.13-.02-.2l-.91-5.49Z",
    style: {
      fill: "#141344"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.19,8.03c-.32-.23-.74-.28-1.12-.15-2.48,.9-4.44,3.87-5.84,8.82-.99,3.49-1.34,6.7-1.35,6.83-.04,.34,.08,.69,.31,.94,.23,.26,.56,.4,.91,.4h5.18v6.1c0,.67,.55,1.22,1.22,1.22s1.22-.55,1.22-1.22V9.02c0-.4-.2-.77-.52-1Zm-1.92,14.41h-3.78c.19-1.23,.54-3.14,1.1-5.11,.75-2.64,1.68-4.65,2.69-5.88v10.99Z",
    style: {
      fill: "#141344"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodIcon);
export default __webpack_public_path__ + "static/media/Food-Icon.1dc43337396f2667a41885ff68c78288.svg";
export { ForwardRef as ReactComponent };